<template>
  <v-speed-dial
    right
    bottom
    fixed
    :style="
      /home|profile|myProfile/.test($route.name) ? 'margin-bottom: 72px' : 0
    "
    direction="left"
    open-on-hover
    transition="slide-x"
  >
    <template v-slot:activator>
      <v-btn
        color="secondary"
        fab
        @click="$store.dispatch('share/openShareModal')"
      >
        <v-icon>fas fa-plus</v-icon>
      </v-btn>
    </template>
  </v-speed-dial>
</template>

<script>
export default {
  name: "ShareButton",
  props: {
    toogleDialog: Function
  }
};
</script>

<style scoped></style>
